module.exports = __webpack_public_path__ + "static/headshot-scott-lundgren-2x.adb4962f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-scott-lundgren-2x.jpg
// module id = 534
// module chunks = 152909308826437